import firebase from 'firebase/app'
import 'firebase/database'

export default {
  namespaced: true,
  state: {
    categories: []
  },
  getters: {
    getCategories (state) {
      return state.categories
    }
  },
  mutations: {
    setCategories (state, payload) {
      state.categories = payload
    }
  },
  actions: {
    async addTemplateCategory ({ dispatch }, category) {
      await firebase
        .database()
        .ref('template_categories')
        .push(category)
      return dispatch('getTemplateCategories')
    },
    async updateTemplateCategory ({ dispatch }, { id, category }) {
      await firebase
        .database()
        .ref('template_categories')
        .child(id)
        .update(category)
      return dispatch('getTemplateCategories')
    },
    async deleteTemplateCategory ({ dispatch }, id) {
      await firebase
        .database()
        .ref('template_categories')
        .child(id)
        .remove()
      return dispatch('getTemplateCategories')
    },
    async getTemplateCategories ({ commit }) {
      const snapshot = await firebase
        .database()
        .ref('template_categories')
        .once('value')

      const categories = await snapshot.val()
      commit('setCategories', categories)
    }
  }
}
